import { Space } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import ChevronLeftIcon from 'components/icons/ChevronLeft';
import IconButton from 'components/new-ui/base/icon-button/IconButton';
import { H2 } from 'components/new-ui/base/typography/styles';
import Button from 'components/new-ui/base/button/Button';
import { DetailHeader } from './styles';
import Tag from 'components/new-ui/base/tag/Tag';

type Props = {
    hasRespondedToCustoms?: boolean;
    onRespondToCustoms?: () => void;
    onBack?: () => void;
};

const DetailsHeader = ({ onBack, onRespondToCustoms, hasRespondedToCustoms = false }: Props) => {
    const action = hasRespondedToCustoms ? (
        <Tag status="success" label="Response Sent to Customs" />
    ) : (
        onRespondToCustoms && (
            <Button type="primary" onClick={onRespondToCustoms}>
                Respond to Customs
            </Button>
        )
    );

    return (
        <DetailHeader>
            <Space size={4}>
                {onBack && <IconButton onClick={onBack} icon={<ChevronLeftIcon />} tooltipText="Back" />}
                <WarningOutlined style={{ color: 'var(--brand-6)' }} />
                <H2>Message Details</H2>
            </Space>

            {action}
        </DetailHeader>
    );
};

export default DetailsHeader;
